import React, { useState } from 'react'

import * as S from './styles'
import Modal from 'presentation/hospital/components/Modal'
import Button from 'presentation/shared/components/Button'
import { DoctorRegister } from '../../../../domain/entities/doctor-register'
import DoctorInTheChurchImg from 'presentation/assets/banners/doctor-in-the-church.svg'
import { toast } from 'react-toastify'
import { useServices } from 'presentation/hooks/use-services'
import { DoctorRegisterStatus } from '../../../../common/enum/doctor-register-status'

export type Props = {
  close: () => void
  doctorRegister?: DoctorRegister
}

export const ConcludeRegisterModal = ({ close, doctorRegister }: Props) => {
  const [showConfirmationContent, setShowConfirmationContent] = useState(false)
  const doctorService = useServices().doctor

  async function handleConcludeRegister() {
    try {
      if (!doctorRegister) toast.error('Cadastro médico não encontrado')
      await doctorService.updateDoctorRegisterStatus({
        doctor_register_id: doctorRegister!.doctor_register_id!,
        status: DoctorRegisterStatus.REGISTER_CONCLUDED
      })
      setShowConfirmationContent(true)
    } catch (error: any) {
      toast.error(error.message)
    }
  }

  return (
    <Modal close={close}>
      <S.Wrapper>
        {showConfirmationContent ? (
          <>
            <S.ConfirmContent>
              <img src={DoctorInTheChurchImg} alt="Médico no altar" />
              <S.Title>O cadastro foi concluído!</S.Title>
            </S.ConfirmContent>
            <S.Buttons>
              <Button type="button" onClick={close}>
                Voltar a Novos Cadastros
              </Button>
            </S.Buttons>
          </>
        ) : (
          <>
            <S.Title>Deseja executar a conclusão deste cadastro?</S.Title>
            <S.Content>
              <div>
                <p>
                  Lembre-se de todas as etapas necessárias antes do fim do
                  processo:
                </p>
                <ul>
                  <li>CNES</li>
                  <li>Treinamento</li>
                  <li>Senhas</li>
                  <li>Crachás</li>
                </ul>
              </div>
            </S.Content>
            <S.Buttons>
              <Button variant="outlined" type="button" onClick={close}>
                Cancelar
              </Button>
              <Button type="button" onClick={handleConcludeRegister}>
                Prosseguir
              </Button>
            </S.Buttons>
          </>
        )}
      </S.Wrapper>
    </Modal>
  )
}
